/*
 * @Author: jzh
 * @Date: 2020-11-17 17:04:11
 * @LastEditors: cgh
 * @LastEditTime: 2022-09-23 15:58:15
 * @Description: 用户维护路由
 */

/* 路由配置说明
 name: 'router-name' // 设定路由的名字，要求唯一性
 webpackChunkName: "sysMenu" // 设置打包模块，要求名称与name一致，唯一性
 meta: {
   navtabTitle: '' // 设置该路由navtabTitle为stringf或者function
   isCache: true  // 设置页面需要缓存，再次打开页面不刷新数据，默认false，设为true缓存页面
   ignoreDiff: [] // 设置判断页面是否相同需忽略的参数，判断处理时默认忽略isRefresh参数，因此isRefresh不需在此设置
   isSecondary: true  // 页面为父页面的一个小页面，不需要展示在tab上作为一个tab页面展示，设置为true，默认false
   isIframe: false // 是否为iframe页面
    menuElements: [ // 路由页面功能元素配置，页面基础的查询实现必须配置
      { elementCode: '**_search', elementName: '查询功能元素' }, // elementCode编码规则：路由name_功能名称（功能名称通用推荐：查询search、新增add、修改edit、更新update、删除del、导出export、下载download）
    ]
 }
*/

const singleUserRoutes = [
  {
    path: 'user',
    name: 'singleUserManage',
    component: () => import(/* webpackChunkName: "attrUserManage" */ '@/features/system/single/user/index.vue'),
    meta: {
      navtabTitle: '用户管理',
      isCache: true,
      ignoreDiff: [],
      menuElements: []
    }
  },
  {
    path: 'addUser/:deptCode',
    name: 'singleAddUser',
    component: () => import(/* webpackChunkName: "attrUserManage" */ '@/features/system/single/user/addUser.vue'),
    meta: {
      navtabTitle: '用户新增',
      isCache: true,
      ignoreDiff: [],
      menuElements: []
    }
  },
  {
    path: 'editUser/:userCode',
    name: 'singleEditUser',
    component: () => import(/* webpackChunkName: "attrUserManage" */ '@/features/system/single/user/editUser.vue'),
    meta: {
      navtabTitle: '用户基本信息修改',
      isCache: true,
      ignoreDiff: [],
      menuElements: []
    }
  }
  // {
  //   path: 'addUser/:deptCode',
  //   name: 'xfcyAddUser',
  //   component: () => import(/* webpackChunkName: "xfcyAddUser" */ '@/features/xfUser/addUser.vue'),
  //   meta: {
  //     navtabTitle: '成员新增',
  //     isCache: true,
  //     ignoreDiff: [],
  //     menuElements: []
  //   }
  // },
  // {
  //   path: 'editUser/:userCode',
  //   name: 'xfcyEditUser',
  //   component: () => import(/* webpackChunkName: "xfcyEditUser" */ '@/features/xfUser/editUser.vue'),
  //   meta: {
  //     navtabTitle: '成员信息修改',
  //     isCache: true,
  //     ignoreDiff: [],
  //     menuElements: []
  //   }
  // }
];

export default singleUserRoutes;
